var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file upload
 * Created by spu-fe on 2017/10/10.
 */

/* global document window Image fetch FormData */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '../Button';
import Link from '../Link';
import { classPrefix } from '../../common/util';

import './Upload.less';

/*
 * 参数说明
 * classPrefix       非必需，自定义前缀
 * className         非必需，自定义类
 * beforeUpload      非必需，使用 beforeUpload 限制用户上传的图片格式和大小,该功能暂未开发
 * name              必需，input name
 * uploadType        非必需，uploadType === 'file-upload'代表文件上传;uploadType === 'image-upload'或type === '',
 *                       代表图片上传(默认图片上传只为向下兼容)
 * containForm       非必需，是否包含表单验证，默认false不包含
 * fileId            必须，file存放唯一标志
 * width             非必需,图片上传宽度
 * height            非必需,图片上传宽度
 * accept            非必需,避免使用accept属性，建议在服务器端验证文件上传（accept='image/png, image/jpeg, image/gif, image/jpg'）
 * validate          非必需，form专用，验证结果
 * noWarning         非必需，警告提示
 * onHandleChange    选项变化时的回调函数
 */

var Upload = function (_Component) {
    _inherits(Upload, _Component);

    function Upload(props) {
        _classCallCheck(this, Upload);

        var _this = _possibleConstructorReturn(this, (Upload.__proto__ || Object.getPrototypeOf(Upload)).call(this, props));

        _this.state = {
            checked: _this.props.checked,
            uploadBtnImg: true,
            uploadStatus: '',
            responseText: {},
            containForm: _this.props.containForm,
            formClick: _this.props.formClick
        };
        _this.uploadChange = _this.uploadChange.bind(_this);
        _this.timeOut = null;
        _this.dataUrl = null;
        _this.widthImg = '';
        _this.heightImg = '';
        return _this;
    }

    _createClass(Upload, [{
        key: 'getImageData',


        // image转dataUrl
        value: function getImageData(imageUrl, callback) {
            var self = this;
            var image = new Image();
            image.src = imageUrl;
            image.onload = function () {
                self.widthImg = image.width;
                self.heightImg = image.height;
                var canvas = document.createElement('canvas');
                canvas.setAttribute('width', self.props.width);
                canvas.setAttribute('height', self.props.height);
                canvas.getContext('2d').drawImage(image, 0, 0, self.props.width, self.props.height);
                callback ? callback(canvas.toDataURL(), {
                    width: image.width,
                    height: image.height
                }) : null;
            };
        }
        // 获取本地文件路径

    }, {
        key: 'getObjectURL',
        value: function getObjectURL(file) {
            var url = null;
            if (window.createObjectURL !== undefined) {
                // basic
                url = window.createObjectURL(file);
            } else if (window.URL !== undefined) {
                // mozilla(firefox)
                url = window.URL.createObjectURL(file);
            } else if (window.webkitURL !== undefined) {
                // webkit or chrome
                url = window.webkitURL.createObjectURL(file);
            }
            return url;
        }
    }, {
        key: 'uploadCallback',
        value: function uploadCallback(file) {
            var _props = this.props,
                increment = _props.increment,
                name = _props.name,
                onHandleChange = _props.onHandleChange;

            if (onHandleChange === null) {
                return;
            }
            onHandleChange({
                name: name,
                value: file
            }, this, 0, increment);
        }
        // 数据请求

    }, {
        key: 'formData',
        value: function formData(fetchUrl, dataUrl, file) {
            var self = this;
            var formDatas = new FormData();
            formDatas.append(this.props.name, file);
            file.formDatas = formDatas;
            file.width = self.widthImg;
            file.height = self.heightImg;

            // action未传值
            if (!fetchUrl) {
                self.uploadCallback(file);
                // self.props.onHandleChange(file);
                return;
            }

            // action传值，upload组件发送后台请求
            var myInit = {
                method: 'POST',
                credentials: 'include',
                body: formDatas
            };
            fetch(fetchUrl, myInit).then(function (response) {
                return response.json();
            }).then(function (response) {
                self.setState({
                    uploadStatus: 'done',
                    responseText: response
                });
                file.status = 'done';
                file.response = response;
                self.uploadCallback(file);
            }, function (error) {
                self.setState({
                    uploadStatus: 'error'
                });
                file.status = 'error';
                file.response = error;
                self.uploadCallback(file);
            });
        }
        // 上传文件判断规则

    }, {
        key: 'fileJudgment',
        value: function fileJudgment(file, fileInfo) {
            if (!this.props.beforeUpload) {
                return true;
            }
            return this.props.beforeUpload(file, fileInfo);
        }
        // 缩略图展示

    }, {
        key: 'showThumbnails',
        value: function showThumbnails(dataUrl) {
            var _this2 = this;

            var addImg = null;
            var fileId = this.props.fileId;
            // 判断img元素是否存在，不存在时创建img
            if (document.getElementById(fileId + '-img')) {
                addImg = document.getElementById(fileId + '-img');
            } else {
                var createImg = document.createElement('img');
                addImg = document.getElementById(this.props.fileId).appendChild(createImg);
                addImg.id = fileId + '-img';
            }
            this.getImageData(dataUrl, function (data) {
                _this2.setState({
                    uploadBtnImg: false
                });
                addImg.src = data;
            });
        }
        // 上传事件

    }, {
        key: 'uploadChange',
        value: function uploadChange() {
            var _this3 = this;

            this.setState({ uploadStatus: 'uploading' });
            var file = document.getElementById(this.props.fileId + '-input').files[0];
            // 防止点开文件窗口取消上传操作
            if (file) {
                if (this.props.uploadType === 'file-upload' || this.props.uploadType === 'text-file-upload') {
                    this.formData(this.props.action, null, file);
                } else {
                    var dataUrl = this.getObjectURL(file);
                    this.getImageData(dataUrl, function (data, fileInfo) {
                        _this3.setState({ uploadBtnImg: false });
                        _this3.fileJudgment(file, fileInfo) && _this3.formData(_this3.props.action, dataUrl, file);
                    });
                }
            }
            // 防止重复选择相同文件时，change事件不触发，这里将input的value置空
            document.getElementById(this.props.fileId + '-input').value = '';
        }
    }, {
        key: 'renderUpload',
        value: function renderUpload() {
            var _classnames;

            var _props2 = this.props,
                width = _props2.width,
                height = _props2.height,
                fileId = _props2.fileId,
                name = _props2.name,
                uploadType = _props2.uploadType,
                validate = _props2.validate,
                noWarning = _props2.noWarning,
                buttonLabel = _props2.buttonLabel,
                buttonProps = _props2.buttonProps,
                className = _props2.className;

            var fileButtonProps = _extends({
                label: buttonLabel
            }, buttonProps);
            var isBtnDisabled = buttonProps.disabled || false;
            var linkProps = {
                label: buttonLabel
            };
            var tpl = React.createElement('input', {
                type: 'file',
                id: fileId + '-input',
                name: name
                // 避免使用accept属性，建议在服务器端验证文件上传
                // accept='image/png, image/jpeg, image/gif, image/jpg'
                , style: { position: 'absolute', clip: 'rect(0 0 0 0)' },
                onChange: this.uploadChange
            });
            var labelClassName = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-upload-primary', true), _defineProperty(_classnames, classPrefix + '-upload-trigger', true), _classnames));
            if (uploadType === 'file-upload') {
                return React.createElement(
                    'div',
                    { className: classPrefix + '-upload-file ' + className },
                    false && React.createElement('div', { className: 'file-container' }),
                    false && React.createElement(
                        'div',
                        { className: 'radio-error-message' },
                        validate && validate.message ? validate.message : ''
                    ),
                    React.createElement(
                        'div',
                        { className: classPrefix + '-upload' },
                        React.createElement(
                            'label',
                            { id: fileId, htmlFor: fileId + '-input' },
                            React.createElement(Button, fileButtonProps)
                        ),
                        isBtnDisabled ? '' : tpl
                    )
                );
            } else if (uploadType === 'text-file-upload') {
                return React.createElement(
                    'div',
                    { className: classPrefix + '-upload-file ' + className },
                    false && React.createElement('div', { className: 'file-container' }),
                    false && React.createElement(
                        'div',
                        { className: 'radio-error-message' },
                        validate && validate.message ? validate.message : ''
                    ),
                    React.createElement(
                        'div',
                        { className: classPrefix + '-upload' },
                        React.createElement(
                            'label',
                            { id: fileId, htmlFor: fileId + '-input' },
                            React.createElement(Link, linkProps)
                        ),
                        tpl
                    )
                );
            } else {
                return React.createElement(
                    'div',
                    { className: classPrefix + '-upload-image ' + className },
                    React.createElement(
                        'div',
                        { className: classPrefix + '-upload', style: { width: width, height: height } },
                        React.createElement('label', {
                            id: fileId,
                            className: labelClassName,
                            htmlFor: fileId + '-input',
                            style: { width: width, height: height }
                        }),
                        tpl
                    ),
                    !(noWarning === true) && React.createElement(
                        'div',
                        { className: classPrefix + '-upload-waining' },
                        validate && validate.message ? validate.message : ''
                    )
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return this.renderUpload();
        }
    }]);

    return Upload;
}(Component);

Upload.defaultProps = {
    width: '150px',
    height: '150px',
    containForm: false,
    formClick: false,
    buttonLabel: '上传文件',
    buttonProps: {},
    classPrefix: classPrefix,
    className: ''
};
Upload.propTypes = {
    beforeUpload: PropTypes.func,
    name: PropTypes.string,
    uploadType: PropTypes.string,
    inForm: PropTypes.bool,
    containForm: PropTypes.bool,
    fileId: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    validate: PropTypes.any,
    noWarning: PropTypes.bool,
    onHandleChange: PropTypes.func,
    checked: PropTypes.bool,
    formClick: PropTypes.bool,
    increment: PropTypes.number,
    action: PropTypes.string,
    buttonLabel: PropTypes.string,
    classPrefix: PropTypes.string,
    className: PropTypes.string,
    buttonProps: PropTypes.object
};
export default Upload;